import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { UpdateDisclaimerUrl } from '../../lib/util';
import styles from './StateSelection.module.scss';
import { IPlan } from '../../interfaces/IPlan';
import * as _ from 'lodash';

const StateSelectionPage = (props: any) => {
  const appContext = useContext(AppContext);
  const plansWithUniqueStates: IPlan[] = _.uniqBy(appContext.plansData, 'state');

  const handleStateSelection = (plan: IPlan) => {
    UpdateDisclaimerUrl(appContext, plan.state);
    appContext.updatePlanState(plan.state);
    appContext.updatePlan(plan);
    appContext.updatePlanCode(plan.contractId);
    props.history.push(
      `/results/${plan.contractId}/${appContext.directoryListType}/${appContext.chosenSpecialty || 'undefined'}/${appContext.name || 'undefined'}/${appContext.location || 'undefined'}`
    );
  };

  return (
    <div>
      <p className={styles.stateSelectionHeader}>Please select a state to continue...</p>
      <hr />
      {plansWithUniqueStates.map((plan: any) => (
        <button key={plan.state} className={styles.stateOption} onClick={() => handleStateSelection(plan)}>
          {plan.state}
        </button>
      ))}
    </div>
  );
};

export default StateSelectionPage;
